import React, {useContext, useState, useEffect, useRef} from 'react';
import _ from "lodash";
import "./miscStudentPaymentForm.scss"
import {useHistory, withRouter} from "react-router-dom";
import {Formik, Form, Field, FieldArray} from "formik";
import { StoreContext } from '../../store/context'
import Paper from '@material-ui/core/Paper';
import { DatePicker } from "@material-ui/pickers";
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import FixedHeaderTable from '../../components/FixedHeaderTable';
import moment from 'moment';
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import {PAYMENT_STATUS_STUDENT_PENDING, PAYMENT_STATUS_STUDENT_PAID} from "../../utils/constants";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import * as yup from 'yup';
import {useViewport} from "../../components/viewport";
const useStyles = makeStyles({
    table: {
        minWidth: 450,
    },
});


const columns = [
    { id: 'name', label: 'Student Name', minWidth: 170 },
    { id: 'programLvl', label: 'Program Level', minWidth: 100 },
    {
        id: 'icNo',
        label: 'NRIC No.',
        minWidth: 170,
        align: 'right',
        format: (value) => value.toLocaleString('en-US'),
    },
    {
        id: 'phoneNo',
        label: 'Phone No.',
        minWidth: 170,
        align: 'right',
    },
    {
        id: 'totalOwedFee',
        label: 'Total Fee',
        minWidth: 110,
        align: 'right'
    },
    {
        id: 'paymentStatus',
        label: 'Status',
        minWidth: 170,
        align: 'right',
        format: (value) => {
            if (value === "PAID"){
                return (<span style={{color: "green", fontWeight:"bold"}}>{value}</span>)
            }
            return (<span style={{color: "red", fontWeight:"bold"}}>{value}</span>) },
    },
    {
        id: 'action',
        label: 'Action',
        minWidth: 170,
        align: 'right',
    },
];

const MiscStudentPaymentForm = () => {
    const classes = useStyles();
    const history = useHistory();
    const { state, actions } = useContext(StoreContext); // get global state and dispatch function
    const { getAllMisc, getAllStudents, getSingleStudentInfoByUuid } = actions.generalActions;
    const { getMiscStudentPayments, getSingleMiscStudentPaymentDetail, showStudentDetailDialog, submitStudentMiscPaymentDetail } = actions.paymentActions;
    const { miscStudentPayment, miscStudentPaymentDetail } = state.paymentStates;
    const { studentDetailDialogVisible } = state.paymentStates;
    const { students, student, misc } = state.generalStates;
    const [selectedTransactionDate, handleTransactionDateChange] = useState(null);
    const [ paymentType, setPaymentType ] = useState(null);
    const formRef = useRef();

    const [programLvl, setProgramLvl] = React.useState(null);
    const [studentName, setStudentName] = React.useState(null);
    const [course, setCourse] = React.useState(2);
    const [errorMsg, setErrorMsg] = useState("");
    const [selectedDate, handleDateChange] = useState(new Date());

    const { width } = useViewport();

    useEffect(() => {
        getAllMisc();
        const month = moment(selectedDate).format('MM-YYYY') ;
        getMiscStudentPayments(month, "", "", course);
    }, []);

    const handlePaymentTypeChange = (event) => {
        setPaymentType(event.target.value);
    };

    const handleChange = (event) => {
        setProgramLvl(event.target.value);
    };

    const handleStudentNameChange = (event) => {
        setStudentName(event.target.value);
    };

    const handleCourseChange = (event) => {
        setCourse(event.target.value);
    };

    const onPayNowClick = (uuid) => {
        showStudentDetailDialog(true);
        getSingleStudentInfoByUuid(null, uuid);
    };

    const handleClose = () => {
        showStudentDetailDialog(false);
    };


    const handlePayNow = () => {
        if (paymentType.length === 0){
            setErrorMsg("Please select ur payment");
            return;
        }

        if (selectedTransactionDate == null){
            setErrorMsg("Please enter your transaction date");
            return;
        }
        setErrorMsg("");

        if (formRef.current) {
            formRef.current.handleSubmit();
        }
    };

    const handleSearchButton = () => {
        const month = moment(selectedDate).format('MM-YYYY') ;
        getMiscStudentPayments(month, studentName, programLvl, course);
    };

    const handleResetButton = () => {
        setStudentName("");
        setProgramLvl("");
    };

    const getTotalAmount = (values) => {
        let totalAmount = 0;
        for (let i = 0; i < values.misc.length; i ++){
            totalAmount += values.misc[i].fee;
        }

        return `Total Amount : RM ${parseFloat(totalAmount).toFixed(2)}`;
    }

    const miscPaymentDetailSchema = yup.object().shape({
        misc: yup.array().of(yup.object().shape({
            id : yup.number().required("Misc are required"),
            fee: yup.number().required("Fee are required")
        })).required("Payment Details are required"),
    });

    const renderStudentDetails = () => {
        return (
            <div>
                <Formik
                    innerRef={formRef}
                    initialValues={{
                        misc: [ { id : "",
                            name: "",
                            fee: "" } ]
                    }}
                    validationSchema={miscPaymentDetailSchema}
                    onSubmit={(values, { setSubmitting, resetForm }) => {
                        // setFormData({studentRegistration : values}); // pass data to global state
                        // resetForm();
                        const transactionDate = moment(selectedTransactionDate).format('DD-MM-YYYY') ;
                        submitStudentMiscPaymentDetail(student.uuid, transactionDate, paymentType, values);
                        showStudentDetailDialog(false);
                        setSubmitting(false);
                    }}>
                    {({ isSubmitting, setFieldValue, values, errors, touched }) => (
                        <div style={{marginTop: "10px"}}>
                            <FieldArray
                                name="misc"
                                render={ arrayHelpers => (
                                    <div>
                                        {values.misc.map((value, index) => {
                                            return (
                                                <div className="miscContainer" key={index}>
                                                    <div className="input-field-container" >
                                                        <Field name={`misc[${index}].id`}>
                                                            {({ field, form: { touched, errors } }) => (
                                                                <>
                                                                    <FormControl variant="filled" className="input-field">
                                                                        <InputLabel>Select Item</InputLabel>
                                                                        <Select {...field}>
                                                                            {
                                                                                misc.map((value, index) => {
                                                                                    return (
                                                                                        <MenuItem key={value.id} value={value.id}>{value.name}</MenuItem>
                                                                                    );
                                                                                })
                                                                            }
                                                                        </Select>
                                                                    </FormControl>
                                                                </>
                                                            )}
                                                        </Field>
                                                        {errors && errors.misc && errors.misc.length > 0 && errors.misc[index] && errors.misc[index].id ? (
                                                            <div className="inline-error">{errors.misc[index].id}</div>
                                                        ) : null}
                                                    </div>

                                                    <div className="input-field-container">
                                                        <Field name={`misc[${index}].fee`}>
                                                            {({ field, form: { touched, errors } }) => (
                                                                <>
                                                                    <TextField
                                                                        {...field}
                                                                        label="Fee"
                                                                        variant="filled"
                                                                        InputProps={{
                                                                            startAdornment: <InputAdornment position="start">RM</InputAdornment>,
                                                                        }}
                                                                        type="number"
                                                                        className="input-field"/>
                                                                </>
                                                            )}
                                                        </Field>
                                                        {errors && errors.misc && errors.misc.length > 0 && errors.misc[index] && errors.misc[index].fee ? (
                                                            <div className="inline-error">{errors.misc[index].fee}</div>
                                                        ) : null}
                                                    </div>
                                                    <div className="button-container">
                                                        <IconButton aria-label="delete" onClick={() => arrayHelpers.remove(index)}>
                                                            <DeleteIcon/>
                                                        </IconButton>
                                                    </div>
                                                </div>
                                            ) //here
                                        })}
                                        <div style={{display: "flex", justifyContent: "flex-end", paddingRight: "30px", marginBottom: "12px"}}>
                                            <h3>{getTotalAmount(values)}</h3>
                                        </div>
                                        <div style={{display: "flex", justifyContent: "flex-end"}}>
                                            <Button variant="contained" color="secondary" onClick={() => arrayHelpers.push({ id : 1, name: "", fee: 0 })} className="submit-button">
                                                Add more misc
                                            </Button>
                                        </div>
                                    </div>
                                )}
                            />
                        </div>)}
                </Formik>
            </div>
        )
    };





    return (
        <div className="misc-student-payment-container">
            <h1 className="header">Student - Misc Fees</h1>
            <div className="paperContainer">
                <DatePicker
                    className="date-picker"
                    views={["year", "month"]}
                    label="Payment Date"
                    value={selectedDate}
                    onChange={handleDateChange}
                />

                <FormControl className="form-control">
                    <InputLabel id="program-lvl-label">Level</InputLabel>
                    <Select
                        labelId="program-lvl-label"
                        value={programLvl}
                        onChange={handleChange}>
                        <MenuItem value={1}>Remove</MenuItem>
                        <MenuItem value={2}>Form 1</MenuItem>
                        <MenuItem value={3}>Form 2</MenuItem>
                        <MenuItem value={4}>Form 3</MenuItem>
                        <MenuItem value={5}>Form 4</MenuItem>
                        <MenuItem value={6}>Form 5</MenuItem>
                        <MenuItem value={8}>Form 5 (Graduated)</MenuItem>
                    </Select>
                </FormControl>

                <FormControl className="form-control">
                    <InputLabel id="courses-label">Course</InputLabel>
                    <Select
                        labelId="courses-label"
                        value={course}
                        onChange={handleCourseChange}>
                        <MenuItem value={2}>Books (Jan - Jun)</MenuItem>
                        <MenuItem value={7}>Books (July - Dec)</MenuItem>
                    </Select>
                </FormControl>

                <TextField className="text-field" label="Student name" onChange={handleStudentNameChange}/>

                <br/>
                <Button className="search-btn" variant="contained" color="primary" onClick={handleSearchButton} style={{marginLeft: "0"}}>
                    Search
                </Button>

                <Button className="search-btn" variant="contained" color="primary" onClick={handleResetButton}>
                    Reset
                </Button>
            </div>

            <div className="table-container">
                {students && <FixedHeaderTable columns={columns} rows={miscStudentPayment} buttonContent="Pay now" buttonAction={onPayNowClick}/>}
            </div>

            <Dialog open={studentDetailDialogVisible} onClose={handleClose} aria-labelledby="form-dialog-title"
                    fullWidth
                    maxWidth = {'md'}>
                <DialogTitle id="form-dialog-title"><h2>Payment Details</h2></DialogTitle>
                <DialogContent>
                    <TextField margin="dense" label="Name"
                               value={student.name ? student.name : ""} fullWidth disabled
                    />
                    <TextField margin="dense" label="Program Level"
                               value={student.name ? student.programLvl : ""} fullWidth disabled
                    />
                    <TextField margin="dense" label="Nric No."
                               value={student.nric ? student.nric : ""} fullWidth disabled
                    />
                    {renderStudentDetails()}
                    <div style={{display: " inline-flex"}}>
                        <div style={{marginTop:"14px"}}>
                            <FormControl className="form-control" style={{minWidth: width > 1000 ? "180px" : "120px"}}>
                                <InputLabel id="payment-type-label">Payment type</InputLabel>
                                <Select
                                    labelId="payment-type-label"
                                    value={paymentType}
                                    onChange={handlePaymentTypeChange}>
                                    <MenuItem value={"CASH"}>Cash</MenuItem>
                                    <MenuItem value={"BANK"}>Bank</MenuItem>
                                </Select>
                            </FormControl>
                        </div>
                        <div style={{marginTop:"14px", marginLeft:"14px"}}>
                            <DatePicker
                                className="date-picker"
                                format="DD/MM/yyyy"
                                views={["year", "month", "date"]}
                                label="Transaction Date"
                                value={selectedTransactionDate}
                                onChange={handleTransactionDateChange}
                            />
                            <div className="inline-error">{errorMsg}</div>
                        </div>
                    </div>
                    <div className="inline-error">{errorMsg}</div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handlePayNow} color="primary">
                        Pay now
                    </Button>
                </DialogActions>
            </Dialog>


        </div>
    )
}

export default withRouter(MiscStudentPaymentForm)
